import { render } from "./AbilityCertification.vue?vue&type=template&id=55f12962&scoped=true"
import script from "./AbilityCertification.vue?vue&type=script&lang=js"
export * from "./AbilityCertification.vue?vue&type=script&lang=js"

import "./AbilityCertification.vue?vue&type=style&index=0&id=55f12962&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55f12962"]])

export default __exports__